import {
  DACIDialog,
  DACIDialogActions,
  DACIDialogContent,
  DACIDialogContentText,
  DACIDialogTitle,
} from "components/DACIDialog";
import MDButton from "components/MDButton";
import PropTypes from "prop-types";

export function UserDelete({ openDelete, closeDelete, infoDelete, submitDelete, requestDelete }) {
  return (
    <>
      <DACIDialog
        open={openDelete}
        onClose={closeDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ textAlign: "center" }}
      >
        <DACIDialogTitle id="alert-dialog-title">{"¡Importante!"}</DACIDialogTitle>
        <DACIDialogContent>
          <DACIDialogContentText id="alert-dialog-description">
            ¿Está seguro de eliminar el usuario: {infoDelete.name} {infoDelete.lastname} ?
          </DACIDialogContentText>
        </DACIDialogContent>
        <DACIDialogActions>
          <MDButton onClick={closeDelete}>Cancelar</MDButton>
          <MDButton color="warning" onClick={submitDelete}>
            Eliminar
          </MDButton>
        </DACIDialogActions>
      </DACIDialog>
    </>
  );
}

UserDelete.propTypes = {
  openDelete: PropTypes.bool,
  closeDelete: PropTypes.func,
  infoDelete: PropTypes.object,
  submitDelete: PropTypes.func,
  requestDelete: PropTypes.func,
};
